import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaTrophy, FaUsers, FaCalendarCheck, FaMedal, FaArrowRight } from 'react-icons/fa';
import './About.css';
import { Helmet } from 'react-helmet';

const KidsPrograms = () => {

    return (
        <>
            <Helmet>
                <title>Kids Programs</title>
            </Helmet>
            <div className="about-page">
                <div className="page-header">
                    <div className="container">
                        <h1>Kids Programs</h1>
                        <div className="breadcrumb">
                            <Link to="/">Home</Link>
                            <span>/</span>
                            <span>Kids Programs</span>
                        </div>
                    </div>
                </div>

                <section className="about-intro section">
                    <div className="container">
                        <div className="about-intro-grid">
                            <div className="about-intro-content">
                                <span className="section-subtitle">Imperial Badminton Academy</span>
                                <h2>Kids Training Program</h2>
                                <p>
                                    At Imperial Badminton Academy, our Kids Training Program is designed to introduce young children to badminton in a fun, safe, and structured way. We believe that early exposure to sports helps children develop physical fitness, discipline, confidence, and a positive attitude toward learning. Our program focuses on building strong fundamentals while ensuring that children enjoy every training session.
                                </p>
                            </div>
                            <div className="about-intro-images">
                                <div className="intro-img-main">
                                    <img src="/img/Kids Programs.jpg" alt="Academy Training" />
                                </div>
                            </div>
                        </div>
                        <div className="about-intro-grid">
                            <div className="about-intro-content">
                                <h3>Who Is This Program For?</h3>
                                <p>
                                    Children aged 5 to 12 years
                                    <br></br>
                                    Beginners with no prior badminton experience
                                    <br></br>
                                    Kids interested in sports and physical activity
                                    <br></br>
                                    Parents looking for structured and safe sports training
                                </p>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Program Philosophy</h3>
                                    <p>
                                        Children learn best when training is enjoyable and engaging. Our coaching approach combines fun-based learning with basic skill development, ensuring kids stay motivated while learning correct techniques. Training sessions are carefully designed to match the child’s age, physical ability, and attention span.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="about-intro-grid">
                            <div className="about-intro-content">
                                <h3>Key Areas of Kids Training</h3>
                                <p>
                                    Holding the racket correctly
                                    <br></br>
                                    Basic forehand and backhand strokes
                                    <br></br>
                                    Simple serves
                                    <br></br>
                                    Understanding the court
                                </p>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Footwork & Body Coordination</h3>
                                    <p>Balance and movement
                                        <br></br>
                                        Coordination and agility
                                        <br></br>
                                        Court awareness</p>
                                </div>
                            </div>
                        </div>
                        <div className="about-intro-grid">
                            <div className="about-intro-content">
                                <h3>Fitness & Physical Development</h3>
                                <p>
                                    Light fitness exercises
                                    <br></br>
                                    Stretching and flexibility routines
                                    <br></br>
                                    Strengthening coordination and stamina
                                </p>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Game Rules & Sports Etiquette</h3>
                                    <p>Fair play
                                        <br></br>
                                        Respect for coaches and teammates
                                        <br></br>
                                        Sportsmanship</p>
                                </div>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Confidence Building & Social Skills</h3>
                                    <p>Express confidence on the court
                                        <br></br>
                                        Communicate with teammates
                                        <br></br>
                                        Develop teamwork and discipline</p>
                                </div>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Safety & Supervision</h3>
                                    <p>Child safety is our top priority. All sessions are conducted under close supervision by trained coaches. Training intensity is kept age-appropriate, ensuring a safe and enjoyable experience for every child.
                                    </p>
                                </div>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Progress Monitoring</h3>
                                    <p>Coaches regularly observe and assess each child’s development. Parents are informed about progress, strengths, and areas of improvement. As skills improve, children are gradually guided toward higher-level training programs.
                                    </p>
                                </div>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Benefits of Kids Training at Imperial Badminton Academy</h3>
                                    <p>Strong foundation in badminton basics
                                        <br></br>
                                        Improved fitness, coordination, and flexibility
                                        <br></br>
                                        Development of discipline and confidence
                                        <br></br>
                                        Positive social interaction and teamwork
                                        <br></br>
                                        Healthy sports habits from an early age
                                    </p>
                                </div>
                            </div>
                            <div className="about-intro-images">
                                <div className="about-intro-content">
                                    <h3>Building the Champions of Tomorrow</h3>
                                    <p>Imperial Badminton Academy’s Kids Training Program focuses on nurturing talent with care, patience, and professionalism. Our goal is to make children love the sport while developing essential life skills through badminton.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default KidsPrograms;
